import useApi from '../../../services/useApi'
import useFilters from '../../../hook/useFilters'
import moment from 'moment'
import {useState} from 'react'

const useGetClassificationReport = () => {
  const [dateRange] = useState(() => JSON.parse(localStorage.getItem('selectedDateRange') || '{}'))
  const Api = useApi()

  const initialFilters = {
    page: 1,
    limit: 50,
    search: '',
    sort_by: 'total_profit/-1',
    start_date: dateRange?.startDate ?? moment().subtract(3, 'months').format('YYYY-MM-DD'),
    end_date: dateRange?.endDate ?? moment().format('YYYY-MM-DD'), // includes today
    classification_filter: '',
  }

  const {filters, onSearch, setMultipleFilters, onSortingChange, onPageChange, onDateChange} =
    useFilters(initialFilters, {sortType: 'number'})

  const {data: response, isFetching} = Api.useGetQuery('/analytics/profitability/classification', {
    queryId: 'classification-report',
    filters,
    isToast: false,
    isErrorPageRedirection: false,
  })

  const onChangeClassificationFilter = (values: any[]) => {
    setMultipleFilters({
      classification_filter: values?.map((item: {value: string}) => item?.value).join(','),
      page: 1,
    })
  }

  const onDownloadCSV = async () => {
    const {page, limit, ...restFilters} = filters
    const response: any = await Api.get('/analytics/profitability/classification/csv', {
      filters: restFilters,
    })
    return {
      message: response?.data?.message,
      status: response?.status,
    }
  }

  return {
    reportData: response?.data || [],
    pagination: response?.meta?.pagination || {},
    isLoading: isFetching,
    filters,
    onSearch,
    onSortingChange,
    onPageChange,
    onDateChange,
    onChangeClassificationFilter,
    onDownloadCSV,
  }
}

export default useGetClassificationReport
